import axios from "axios";
import { endpoints } from "../config/api";
import axiosErrorHandler from "./axiosHelpers";
import { axiosInstance } from "./utilities";
const token = localStorage.getItem("token");

export const GetTruckDeatilsbyid = async (params) => {
  const request = await axiosInstance.get(
    endpoints.GraiManager.GET_TRUCK_BY_ID,
    { params },
  ).catch(axiosErrorHandler);
  return request;
};

export const getTruckDetailsByUniqueCode = async (params) => {
  const request = await axiosInstance.get(
    endpoints.GraiManager.GET_TRUCK_BY_UNIQUECODE,
    { params },
  ).catch(axiosErrorHandler);
  return request;
};

export const getTruckDetailsList = async (params) => {
  const request = await axiosInstance.get(

    endpoints.GraiManager.GET_TRUCK_BY_TRUCKDETAILSLIST,

    { params },
  ).catch(axiosErrorHandler);
  return request;
};

export const editWeighbridgeDetails = async (body, id) => {
  const request = await axiosInstance.put(

    `${endpoints.GraiManager.UPDATE_WEIGHBRIDGEDETAILS}?truckDetailsId=${id}`,

    body,
  ).catch(axiosErrorHandler);
  return request;
};

export const addQualityCheck = async (body) => {
  const request = await axiosInstance.post(
    endpoints.GraiManager.CREATE_QUALITY_CHECK,
    body,
  ).catch(axiosErrorHandler);
  return request;
};

export const addGSLDetails = async (body) => {
  const request = await axiosInstance.post(
    endpoints.GraiManager.CREATE_GSL_DETAILS,
    body,
  ).catch(axiosErrorHandler);
  return request;
};

export const addDepositUpdateId = async (body) => {
  const request = await axiosInstance.post(
    endpoints.GraiManager.CREATE_DEPOSIT_UPDATE,
    body,
  ).catch(axiosErrorHandler);
  return request;
}

export const addDepositDetails = async (body) => {
  const request = await axiosInstance.post(
    endpoints.GraiManager.CREATE_DETAILS,
    body,
  ).catch(axiosErrorHandler);
  return request;
}

export const updateDepositDetails = async (body, id) => {
  const request = await axiosInstance.put(

    `${endpoints.GraiManager.UPDATE_DEPOSIT_DETAILS}?id=${id}`,

    body,
  ).catch(axiosErrorHandler);
  return request;
};

export const getAllVendorsList = async (params) => {
  const request = await axiosInstance
    .get(endpoints.GraiManager.GET_ALL_VENDOR_LIST, { params })
    .catch(axiosErrorHandler);
  return request;
};

export const getLotNumber = async (params) => {
  const request = await axiosInstance
    .get(endpoints.GraiManager.GET_LOT_NUMBER, { params })
    .catch(axiosErrorHandler);
  return request;
};

export const getGoDownNumber = async (params) => {
  const request = await axiosInstance
    .get(endpoints.GraiManager.GET_GO_DOWN_NUMBER, { params })
    .catch(axiosErrorHandler);
  return request;
};

export const getDepositUpdatesId = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.GraiManager.GET_DEPOSIT_UPDATE,
      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const getReleaseTruckDetailsList = async (params) => {
  const request = await axiosInstance.get(
    endpoints.GraiManager.GET_RELEASE_MODULE_LIST,
    { params },
  ).catch(axiosErrorHandler);
  return request;
};

export const GetTruckReleasesbyid = async (params) => {
  const request = await axiosInstance.get(
    endpoints.GraiManager.GET_RELEASE_BY_ID,
    { params },
  ).catch(axiosErrorHandler);
  return request;
};

export const GetTruckReleasesQuantitybyid = async (id) => {
  const request = await axiosInstance.get(
    `${endpoints.GraiManager.UPDATE_TRUCK_DETAILS}?id=${id}`,
  ).catch(axiosErrorHandler);
  return request;
};

export const GetTruckReleasesInvoicebyid = async (id) => {
  const request = await axiosInstance.get(
    `${endpoints.GraiManager.UPDATE_TRUCK_INVOICE_DETAILS}?id=${id}`,
  ).catch(axiosErrorHandler);
  return request;
};

export const updateReleaseDetailsDetails = async (body, id) => {
  const request = await axiosInstance.put(
    `${endpoints.GraiManager.
      UPDATE_RELEASE_MODULE}?id=${id}`,
    body,
  ).catch(axiosErrorHandler);
  return request;
};

export const updateReleaseDetailsDetailsNew = async (body, id) => {
  const request = await axiosInstance.post(
    `${endpoints.GraiManager.
      UPDATE_RELEASE_MODULE_NEW}?id=${id}`,
    body,
  ).catch(axiosErrorHandler);
  return request;
};

export const updateReleaseDetailsInvoiceNew = async (body) => {
  const request = await axiosInstance.post(
    `${endpoints.GraiManager.
      UPDATE_RELEASE_INVOICE}`,
    body,
  ).catch(axiosErrorHandler);
  return request;
};

export const updateTruckDetailsNewGet = async (id) => {
  const request = await axiosInstance.get(
    `${endpoints.GraiManager.
      TRUCK_NEW_GET_API}?id=${id}`,
  ).catch(axiosErrorHandler);
  return request;
};

export const updateMobileOtpDigitalSign = async (body) => {
  const request = await axiosInstance.post(
    `${endpoints.GraiManager.
      POST_OTP_DIGITALSIGN}`,
    body,
  ).catch(axiosErrorHandler);
  return request;
};

export const getQrPending = async (params) => {
  const request = await axiosInstance.get(
    endpoints.GraiManager?.GET_QR_PENDING,
    { params },
  ).catch(axiosErrorHandler);
  return request;
};

export const getweightment = async (params) => {
  const request = await axiosInstance.get(
    endpoints.GraiManager?.GET_WEIGHTMENT,
    { params },
  ).catch(axiosErrorHandler);
  return request;
};

export const getCommodityReleaseList = async (params) => {
  const request = await axiosInstance.get(
    endpoints.customer?.COMMODITY_RELEASE_LIST,
    { params },
  ).catch(axiosErrorHandler);
  return request;
};

export const updateReleaseTruckDetails = async (body, id) => {
  const request = await axiosInstance.put(
    `${endpoints.customer.COMMODITY_RELEASE_UPDATE}?id=${id}`,
    body,
  ).catch(axiosErrorHandler);
  return request;
};

